import script from "./MemberTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./MemberTabs.vue?vue&type=script&lang=ts&setup=true"

import "./MemberTabs.vue?vue&type=style&index=0&id=1d99ef26&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d99ef26"]])

export default __exports__